module.exports = __webpack_public_path__ + "img/btn-toDetail.b323fe64.png";